"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimationTypes = exports.LayerContextType = exports.OrderedLayers = exports.Layers = void 0;

var _LayerAnimationTypes = require("./LayerAnimationTypes");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Layers = {
  PopoverContent: 'POPOVER_CONTENT',
  Sheet: 'SHEET',
  Modal: 'MODAL',
  PopoverModal: 'POPOVER_MODAL'
};
exports.Layers = Layers;
var OrderedLayers = [// Bottom layer
Layers.PopoverContent, Layers.Sheet, Layers.Modal, Layers.PopoverModal // Top layer
];
exports.OrderedLayers = OrderedLayers;
var LayerContextType = _propTypes["default"].string;
exports.LayerContextType = LayerContextType;
var AnimationTypes = {
  None: _LayerAnimationTypes.None,
  Slide: _LayerAnimationTypes.Slide,
  SlideDown: _LayerAnimationTypes.SlideDown,
  Fade: _LayerAnimationTypes.Fade,
  Custom: 'Custom'
};
exports.AnimationTypes = AnimationTypes;